import PropTypes from 'prop-types';
import React from 'react';
import { Field } from 'react-final-form';
import {
  DateField,
  RadioField,
  SimpleSelectField,
} from '@unite-us/app-components';
import formatOptions from 'common/utils/formatOptions';

const getFieldError = (meta) => (meta.touched && meta.error ? meta.error : undefined);

const dateFieldKey = (value) => value || 'empty';

function MilitaryServiceFields({ militaryEnums }) {
  return (
    <>
      <Field name="current_status">
        {({ input, meta }) => (
          <SimpleSelectField
            id="current_status"
            label="Current Status"
            value={input.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            options={formatOptions(militaryEnums.current_status)}
            optionSettings={{ labelKey: 'label', valueKey: 'value' }}
            error={getFieldError(meta)}
          />
        )}
      </Field>
      <div className="form-group">
        <div className="control-label">Currently Transitioning?</div>
        <Field name="currently_transitioning">
          {({ input, meta }) => (
            <RadioField
              id="transitioning"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              options={formatOptions(militaryEnums.transitioning)}
              error={getFieldError(meta)}
            />
          )}
        </Field>
      </div>
      <div className="form-group">
        <div className="control-label">Has at least one day of active duty outside of basic training?</div>
        <Field name="at_least_one_day_active_duty">
          {({ input, meta }) => (
            <RadioField
              id="active-duty"
              value={input.value}
              onChange={input.onChange}
              onBlur={input.onBlur}
              options={formatOptions(militaryEnums.active_duty)}
              error={getFieldError(meta)}
            />
          )}
        </Field>
      </div>
      <Field name="branch">
        {({ input, meta }) => (
          <SimpleSelectField
            id="branch"
            label="Branch Of Service"
            value={input.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            options={formatOptions(militaryEnums.branch)}
            optionSettings={{ labelKey: 'label', valueKey: 'value' }}
            error={getFieldError(meta)}
          />
        )}
      </Field>
      <Field name="service_era">
        {({ input, meta }) => (
          <SimpleSelectField
            id="era"
            label="Service Era"
            value={input.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            options={formatOptions(militaryEnums.service_era)}
            optionSettings={{ labelKey: 'label', valueKey: 'value' }}
            error={getFieldError(meta)}
          />
        )}
      </Field>
      <div className="form-group">
        <h6>Service Dates</h6>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <Field name="entry_date">
              {({ input, meta }) => (
                <DateField
                  key={dateFieldKey(input.value)}
                  {...input}
                  id="service-dates-start"
                  label="Start Date"
                  error={getFieldError(meta)}
                />
              )}
            </Field>
          </div>
          <div className="col-xs-12 col-sm-6">
            <Field name="exit_date">
              {({ input, meta }) => (
                <DateField
                  key={dateFieldKey(input.value)}
                  {...input}
                  id="service-dates-end"
                  label="End Date"
                  error={getFieldError(meta)}
                />
              )}
            </Field>
          </div>
        </div>
      </div>
    </>
  );
}

MilitaryServiceFields.propTypes = {
  militaryEnums: PropTypes.object.isRequired,
};

export default MilitaryServiceFields;
